import { Col, Container, Grid } from "@components/layout/Grid"
import { cn } from "@utils/tw"
import { ComponentPropsWithoutRef, forwardRef } from "react"

export const Showing = forwardRef<HTMLSpanElement, ComponentPropsWithoutRef<"span">>(({ className, ...props }, ref) => (
  <span ref={ref} className={cn("type-label-caps py-2 inline-block", className)} {...props} />
))
Showing.displayName = "Showing"

export const SelectedFiltersChips = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<"div">>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("flex gap-1 flex-wrap md:justify-end", className)} {...props} />
  ),
)
SelectedFiltersChips.displayName = "SelectedFiltersChips"

export const Loader = ({ listView }: { listView?: boolean }) => {
  const rows = []
  for (let i = 0; i < 20; i++) {
    rows.push(
      <li key={i}>
        <Row />
      </li>,
    )
  }

  const fakecards = []
  for (let i = 0; i < 12; i++) {
    fakecards.push(
      <Col initial={12} bigPhone={6} desktop={4} key={i}>
        <FakeCard />
      </Col>,
    )
  }

  return (
    <>
      <Col initial={12} tablet={6} laptop={4}>
        <Placeholder />
      </Col>

      <Col initial={12} tablet={6} laptop={8}>
        <SelectedFiltersChips>
          <LoaderChip />
          <LoaderChip />
        </SelectedFiltersChips>
      </Col>

      {listView ? (
        <Col initial={12}>
          <ul>{rows}</ul>
        </Col>
      ) : (
        <>{fakecards}</>
      )}
    </>
  )
}

const Placeholder = () => <span className="w-full h-[1em] block rounded-md my-2 animate-skeleton-loading" />

const LoaderChip = () => <div className="flex h-[20px] rounded-[10px] px-2 w-[100px] animate-skeleton-loading" />

const Row = () => <div className="flex h-[44px] mt-[44px] rounded-[10px] px-2 w-full animate-skeleton-loading" />

const FakeCard = () => (
  <div className="flex w-full rounded-[10px] p-[calc(var(--spacing-4)+35.3%)_var(--spacing-4)_var(--spacing-4)_var(--spacing-4)] animate-skeleton-loading" />
)

export const TaxonomyContainer = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Container>>(
  ({ className, ...props }, ref) => (
    <Container
      ref={ref}
      className={cn("[&_h1]:w-full [&_h1]:text-center [&_h1]:block [&_h1]:py-8", className)}
      {...props}
    />
  ),
)
TaxonomyContainer.displayName = "TaxonomyContainer"

export const ArchiveGrid = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof Grid>>(
  ({ className, ...props }, ref) => <Grid ref={ref} className={cn("gap-y-4 lg:gap-y-6", className)} {...props} />,
)
ArchiveGrid.displayName = "ArchiveGrid"
